export const USER_TYPES = {
  POS: 1,
  KITCHEN: 2,
  WAITER: 3,
};

export const HANDLE_OTHER_WAITER_TABLE = 'Handle Other Waiter Table';

const FULL_ACCESS_ROLES = ['System Administrator', 'Admin'];

export function hasFullAccess(authState) {
  const role = authState && authState.user && authState.user.role;
  return FULL_ACCESS_ROLES.includes(role);
}

export function canAccessWaiterPortal(authState) {
  if (!authState) return false;
  const usertype = Number(authState.user && authState.user.usertype);
  if (usertype === USER_TYPES.WAITER) return true;
  const policies = authState.permissions || [];
  return policies.includes('Waiter Index');
}

export function canHandleOtherWaiterTable(authState) {
  if (hasFullAccess(authState)) return true;
  const policies = (authState && authState.permissions) || [];
  return policies.includes(HANDLE_OTHER_WAITER_TABLE);
}

export function assignedWaiterId(record) {
  if (!record) return null;
  return (
    record.waiter_id
    || (record.waiter && record.waiter.id)
    || (record.order && record.order.waiter_id)
    || (record.order && record.order.waiter && record.order.waiter.id)
    || null
  );
}

export function isTableLockedToOtherWaiter(authState, recordOrWaiterId) {
  const waiterId = recordOrWaiterId && typeof recordOrWaiterId === 'object'
    ? assignedWaiterId(recordOrWaiterId)
    : recordOrWaiterId;
  if (!waiterId) return false;
  if (canHandleOtherWaiterTable(authState)) return false;
  const mine = authState && authState.user && authState.user.waiter_id;
  if (mine && Number(mine) === Number(waiterId)) return false;
  return true;
}

export function isWaiterOnlyUser(authState) {
  return Number(authState && authState.user && authState.user.usertype) === USER_TYPES.WAITER;
}

export function isKitchenUser(authState) {
  return Number(authState && authState.user && authState.user.usertype) === USER_TYPES.KITCHEN;
}
